import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import TPLog from "../widget/og.mustache";
import TPLogGiphy from "../widget/og-giphy.mustache";

  var
    https = window.location.toString().indexOf('https')===0,
    cache = {};

  ApiServer.types.OpenGraphMedia.prototype.onDecode = function(){
    this.chosenUrl = https?this.secureUrl:this.url;
    this.isSmall = this.width && this.height && this.width*this.height < 10000;
    if(this.width && this.height){
      this.deltaWidth = -(this.width/this.height*200 - 300)/2;
    }
  };
  ApiServer.types.OpenGraphDataBean.prototype.onDecode = function(){
    this.iframes = this.videos.filter(function(vid){
      return vid.type==='text/html';
    })

    this.videos = this.videos.filter(function(vid){
      return vid.type==='video/mp4';
    })
    this.useVideo = this.videos.length>0;
    this.useIframe = !this.useVideo && this.iframes.length>0;
    this.useImage = !this.useVideo && !this.useIframe && this.images.length;
    this.useNone = !this.useVideo && !this.useIframe && !this.useImage;
  };


  function initDom(node: HTMLElement){
    var
      href = node.getAttribute('href');

    node.removeAttribute('data-widget');


      ApiServer.webog(href,function(ogbean){
        cache[href] = ogbean;
        ogbean.askedURL = href;
        var targetHeight = node.getBoundingClientRect().height;
        if(!ogbean.useNone){
          if(node.getAttribute('giphy')){
            node = Html.replaceWithSingleDom(node,TPLogGiphy,ogbean);
          }else{
            node = Html.replaceWithSingleDom(node,TPLog,ogbean);
          }
        }else{
          node.setAttribute('target','_new');
          node.textContent = href;
        }
        // Trigger afterupdate event
        const event = new CustomEvent('afterupdate', { detail: node.getBoundingClientRect().height - targetHeight });
        node.dispatchEvent(event);

      },function(err){
        if(err.code==="502"){
          // Replace with inner HTML
          const parent = node.parentElement;
          if(parent){
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = node.innerHTML;
            parent.replaceChild(tempDiv.firstChild || tempDiv, node);
          }
        }else{
          console.log(err)
        }
      });

  }
  Html.registerWidget('widget/og',{initDom:initDom})

  export {
    cache,
    initDom
  }